import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerService } from '../services/ServerService';

@Injectable({ providedIn: 'root' })
export class CardapioAnalyticsService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  obtenhaDashboard(params: {
    range?: string;
    startDate?: string;
    endDate?: string;
    previous?: boolean;
    interval?: string;
  } = {}): Promise<any> {
    const query: any = {};
    if (params.range) query.range = params.range;
    if (params.startDate) query.startDate = params.startDate;
    if (params.endDate) query.endDate = params.endDate;
    if (params.previous) query.previous = 'true';
    if (params.interval) query.interval = params.interval;

    return this.obtenha('/api/dashboard/cardapio/', query);
  }

  obtenhaAnalytics(params: {
    range?: string;
    startDate?: string;
    endDate?: string;
    previous?: boolean;
    interval?: string;
  } = {}): Promise<any> {
    const query: any = {};
    if (params.range) query.range = params.range;
    if (params.startDate) query.startDate = params.startDate;
    if (params.endDate) query.endDate = params.endDate;
    if (params.previous) query.previous = 'true';
    if (params.interval) query.interval = params.interval;

    return this.obtenha('/api/dashboard/cardapio/analytics', query);
  }

  obtenhaStatus(): Promise<any> {
    return this.obtenha('/api/dashboard/cardapio/status', {});
  }

  obtenhaTempoReal(janelaMinutos: number = 30): Promise<any> {
    return this.obtenha('/api/dashboard/cardapio/tempo-real', { janelaMinutos });
  }

  obtenhaUrlExportacao(tipo: string, params: any = {}): string {
    const query = new URLSearchParams();
    if (params.range) query.set('range', params.range);
    if (params.startDate) query.set('startDate', params.startDate);
    if (params.endDate) query.set('endDate', params.endDate);
    const qs = query.toString();
    return `/api/dashboard/cardapio/export/${tipo}${qs ? '?' + qs : ''}`;
  }
}
